import { Input } from './input.interface';

export type FormButtonType = 'callback' | 'routerLink' | 'externalLink';

export interface FormButton {
    type?: FormButtonType;
    label: string;
    icon?: string;
    class?: string;
    style?: string | Record<string, string>;
    isVisible?: boolean;
    function?: () => void;
    route?: Array<string | number>;
    queryParams?: Record<string, unknown>;
    fragment?: string;
    href?: string;
    target?: string;
    rel?: string;
    tooltip?: string;
    tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
    tooltipEvent?: 'hover' | 'focus';
}

export interface Form<T> {
    name: string,
    header: string,
    type: FormType,
    sections: FormSection<T>[],
    table: FormTable | null,
    uploadButton: {
        isEnabled: boolean,
        label: string
    },
    /**
     * Header buttons rendered next to the upload button.
     * `button` is kept for backward compatibility with legacy forms.
     */
    button?: FormButton | FormButton[],
    buttons?: FormButton[],
    signed: boolean
}

export interface FormSection<T> {
    name: string,
    fields: FormField<T>[],
    buttons?: FormButton[],
    tables?: FormTable[],
    width: number,
    isVisible: boolean,
    order: number
}

export interface FormField<T> {
    [key: string]: 
        ((it: FormField<T>) => T | string | null | undefined) |
        ((it: FormField<T>) => void) |
        Input<T> |
        FormFieldConditions |
        string[] | 
        string | 
        number | 
        boolean |
        FormButton[] |
        any | 
        undefined;
    name: string;
    vinculatedFields: string[] | undefined;
    label: string;
    input: Input<T>;
    checkForDuplicates?: (it: string) => boolean;
    width: number,
    conditions: FormFieldConditions;
    buttons?: FormButton[],
    order: number;    
    turnVisible?: (it: FormField<T>) => void;
    updateValue?: (it: FormField<T>) => T | string | null | undefined;
}

export interface FormTable {
    title: string,
    showIndex: boolean,
    data: string[] | string[][] | undefined, 
    style: string[] | string[][] | undefined
}

export interface FormFieldConditions {
    isRememberedOnDuplicate: boolean;
    isRequired: boolean;
    isRetained: boolean;
    hasUndoEnabled: boolean;
    isVisible: boolean;
}

export enum FormType {
    CREATION,
    EDITION,
    DUPLICATION,
    DELETION,
    INFORMATIVE,
    EXPORT,
    GENERATION
}
